/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class RequiredUserActionsDaoService implements Resetable {
  public abstract saveRequiredUserActionsData(
    requiredUserActionsData: any,
  ): Promise<void>;
  public abstract getRequiredUserActionsData(): Promise<any>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
